var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var Feature;
(function (Feature) {
    Feature["MEMBERSHIPS"] = "memberships";
    Feature["CONTESTS"] = "contests";
    Feature["CONTEST_POST"] = "contestPost";
    Feature["LOCAL_JOBS"] = "localJobs";
    Feature["SHOWCASE"] = "showcase";
    Feature["SEARCH"] = "search";
    Feature["SEARCH_CONTESTS"] = "searchContests";
    Feature["SEARCH_POOLS"] = "searchPools";
    Feature["COMMUNITY"] = "community";
    Feature["REFER_A_CLIENT"] = "referAClient";
    Feature["GIVE_GET"] = "giveGet";
    Feature["HOW_IT_WORKS_PAGE"] = "howItWorksPage";
    Feature["ENTERPRISE_PAGE"] = "enterprisePage";
    Feature["ABOUT_FLNLTD_PAGES"] = "aboutFlnltdPages";
    Feature["PROJECT_MANAGEMENT_PAGE"] = "projectManagementPage";
    Feature["SERVICES"] = "services";
    Feature["POLLS"] = "polls";
    Feature["GAMIFICATION"] = "gamification";
    Feature["PREFERRED_FREELANCER_PROGRAM"] = "preferredFreelancerProgram";
    Feature["FILEUPLOAD"] = "fileUpload";
    Feature["PORTFOLIO"] = "portfolio";
    Feature["LEGACY_FREELANCER_PROJECT_VIEW_PAGE"] = "legacyFreelancerProjectViewPage";
    Feature["VERIFICATIONS"] = "verifications";
    Feature["PROFILE_HOURLY_RATE"] = "profileHourlyRate";
    /** The `/jobs/<skill_seo_url>` page */
    Feature["JOBS_SEO_PAGE"] = "jobsSeoPage";
    Feature["ACCOUNT_BALANCE"] = "accountBalance";
    Feature["BILLING"] = "billing";
    Feature["PROJECT_UPGRADES"] = "projectUpgrades";
    Feature["LEGACY_PROFILE_PAGE"] = "legacyProfilePage";
    Feature["EXAMS"] = "exams";
    Feature["INSIGHTS"] = "insights";
    Feature["RECRUITER"] = "recruiter";
    Feature["EMPLOYER_MILESTONE_MODALS"] = "employerMilestoneModals";
    Feature["FREELANCER_APPS"] = "freelancerApps";
    Feature["COLLABORATION"] = "collaboration";
    Feature["DASHBOARD_ACCOUNT_SETUP_SECTION"] = "dashboardAccountSetupSection";
    /** navigation  */
    Feature["DASHBOARD_FEEDBACK_PAGE"] = "dashboardFeedbackPage";
    Feature["DISPUTE"] = "dispute";
    /** directory search */
    Feature["DEPRECATED_SEARCH_PAGES"] = "deprecatedSearchPages";
    Feature["FREELANCER_RATING"] = "freelancerRating";
    Feature["SITE_MAP"] = "siteMap";
    Feature["DESKTOP_APP"] = "desktopApp";
    Feature["DISPLAY_USERNAME"] = "displayUsername";
    Feature["VIEW_REVIEW"] = "viewReview";
    Feature["REPOST_PROJECT"] = "repostProject";
    Feature["BOOKMARKS"] = "bookmarks";
    Feature["TIPPING"] = "tipping";
    Feature["CHANGE_EMAIL"] = "changeEmail";
    Feature["ACTIVITY_VIEWER_TRACKING"] = "activityViewerTracking";
    Feature["NDA_HIDDEN_DESCRIPTION"] = "ndaHiddenDescription";
})(Feature || (Feature = {}));
export var SiteTheme;
(function (SiteTheme) {
    SiteTheme["DEFAULT"] = "default";
    SiteTheme["ARROW"] = "arrow";
    SiteTheme["DELOITTE"] = "deloitte";
})(SiteTheme || (SiteTheme = {}));
// FIXME: Compile static configurations from single-source of truth
var DEFAULT_CONFIGURATION = {
    memberships: true,
    contests: true,
    contestPost: true,
    localJobs: true,
    showcase: true,
    search: true,
    searchPools: true,
    searchContests: true,
    community: true,
    referAClient: true,
    giveGet: true,
    howItWorksPage: true,
    enterprisePage: true,
    aboutFlnltdPages: true,
    projectManagementPage: true,
    services: true,
    polls: true,
    gamification: true,
    preferredFreelancerProgram: true,
    fileUpload: true,
    portfolio: true,
    legacyFreelancerProjectViewPage: true,
    verifications: true,
    profileHourlyRate: true,
    jobsSeoPage: true,
    accountBalance: true,
    billing: true,
    projectUpgrades: true,
    legacyProfilePage: true,
    exams: true,
    insights: true,
    recruiter: true,
    employerMilestoneModals: true,
    freelancerApps: true,
    collaboration: true,
    dashboardAccountSetupSection: true,
    dashboardFeedbackPage: true,
    dispute: true,
    deprecatedSearchPages: true,
    freelancerRating: true,
    siteMap: true,
    desktopApp: true,
    displayUsername: true,
    viewReview: true,
    repostProject: true,
    bookmarks: true,
    tipping: true,
    changeEmail: true,
    activityViewerTracking: true,
    ndaHiddenDescription: false,
};
export var featureFlagConfigurations = {
    default: DEFAULT_CONFIGURATION,
    arrow: __assign({}, DEFAULT_CONFIGURATION, { memberships: false, contestPost: false, localJobs: false, showcase: false, search: false, searchContests: false, community: false, giveGet: false, howItWorksPage: false, enterprisePage: false, aboutFlnltdPages: false, projectManagementPage: false, services: false, polls: false, gamification: false, preferredFreelancerProgram: false, jobsSeoPage: false, projectUpgrades: false, employerMilestoneModals: false, deprecatedSearchPages: false, repostProject: false, bookmarks: false, changeEmail: false, tipping: true, activityViewerTracking: true, ndaHiddenDescription: true }),
    deloitte: __assign({}, DEFAULT_CONFIGURATION, { memberships: false, contests: false, contestPost: false, localJobs: false, showcase: false, searchContests: false, community: false, referAClient: false, giveGet: false, enterprisePage: false, projectManagementPage: false, services: false, polls: false, gamification: false, preferredFreelancerProgram: false, fileUpload: false, portfolio: false, legacyFreelancerProjectViewPage: false, verifications: false, profileHourlyRate: false, jobsSeoPage: false, accountBalance: false, billing: false, projectUpgrades: false, legacyProfilePage: false, exams: false, insights: false, recruiter: false, employerMilestoneModals: false, freelancerApps: false, collaboration: false, dashboardAccountSetupSection: false, dashboardFeedbackPage: false, dispute: false, deprecatedSearchPages: false, freelancerRating: false, siteMap: false, desktopApp: false, displayUsername: false, viewReview: false, repostProject: false, bookmarks: false, tipping: false, activityViewerTracking: false, ndaHiddenDescription: false }),
};
